import RoundButton from '@innovyze/stylovyze/lib/components/RoundButton';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import React from 'react';
export default function ToggleExpandButton({ menuOpen, color, onClick, ...props }) {
    return (React.createElement(RoundButton, { onClick: onClick }, menuOpen ? (React.createElement(ExpandLess, { color: color || 'secondary', ...props })) : (React.createElement(ExpandMore, { color: color || 'secondary', ...props }))));
}
